import * as React from "react";
import { getSupportItemOrList } from "@services/api";
import { useNavigation } from "@react-navigation/native";
import FormRenderer from "../components/Form/FormRenderer";
import OrderList from "../components/OrderList";
import Loader from "../components/CoverLoader";
import { actions } from "@reducers/supportReducer";
import { useDispatch } from "react-redux";
import navigateToListOrItem from "../utils/navigateToListOrItem";
import exit from "../utils/exit";

import analytics from "@services/analytics";
import { SUPPORT_FLOW } from "@constants/analyticsEventsCT";
import CreateTicketDialog from "../components/CreateTicketDialog";

const componentsByType = {
  FORM: FormRenderer,
  ORDER_ITEMS: OrderList,
};

const SupportItem = ({ route }) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState();
  const [fetching, setFetching] = React.useState(true);

  React.useEffect(() => {
    (async function () {
      try {
        const { params } = route;
        const { data } = await getSupportItemOrList({
          type: "ITEM",
          id: params && params.id,
          item_id: params && params.item_id ? params.item_id : "",
        });
        analytics.trackEvent(SUPPORT_FLOW.SUPPORT_TICKET_SUCCESS);
        const { config = {}, tickets = [] } = data;
        if (config.item_type === "EXIT") {
          exit(config);
        }
        setItem(config);

        setFetching(false);

        navigation.setParams({
          headerTitle: config?.title || "",
          numberOfLines: 2,
          headerStyle: { width: "80%" },
        });
      } catch (e) {
        console.log("some error on support iem screenF");
        console.log(e);
      }
    })();
    return () => {};
  }, [route.params.id]);

  if (fetching || !item || !item.render) {
    return <Loader />;
  }

  const Component = componentsByType[item.render];

  return (
    <>
      <CreateTicketDialog />
      <Component
        {...item}
        onSubmit={(data) => {
          const { dataKey, render } = item;
          dispatch(
            actions.updateSupportTicketPayload({
              dataKey,
              render,
              value: data,
            }),
          );
          navigateToListOrItem(item);
        }}
      />
    </>
  );
};

export default SupportItem;
